import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer: React.FC = () => {
  const navigate = useNavigate();

  const handlePrivacyClick = () => {
    navigate('/privacidade');
  };

  const handleTermsClick = () => {
    navigate('/termos');
  };

  return (
    <footer className="bg-light border-top py-3 mt-auto">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-12 text-center">
            <p className="mb-0 text-muted small">
              © {new Date().getFullYear()} SystemLoc. Todos os direitos reservados. |{' '}
              <button
                type="button"
                className="btn btn-link p-0 text-decoration-none text-muted"
                onClick={handlePrivacyClick}
                style={{ fontSize: 'inherit' }}
              >
                Política de Privacidade
              </button>
              {' | '}
              <button
                type="button"
                className="btn btn-link p-0 text-decoration-none text-muted"
                onClick={handleTermsClick}
                style={{ fontSize: 'inherit' }}
              >
                Termos de Uso
              </button>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
